import {
  SearchOutlined,
  RedoOutlined,
  ExclamationCircleOutlined,
  FileDoneOutlined,
  CheckCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  Space,
  Table,
  Form,
  Row,
  Col,
  DatePicker,
  Select,
  message,
  Tag,
} from "antd/lib";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GetQuotes } from "../../Redux/actions/NumBikeation";

import moment from "moment";
// import { useSelector } from "react-redux";
import Highlighter from "react-highlight-words";
export default function BpoRemarks() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const { Option } = Select;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [loading, setLoading] = useState(false);
  // const [entries, setEntries] = useState('10');
  const [data, setData] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 6,
    },
  });
  useEffect(() => {
    dispatch(GetQuotes())
      .then((res) => {
        console.log(res);
        let RemarkDatas = res?.data;
        const filteredData = RemarkDatas?.filter(
          (item) => item?.remarks !== null
        );
        console.log(filteredData);
        setData(filteredData);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: res.data.total,
          },
        });
      })
      .catch((err) => {
        console.log(err);
        console.log(err?.response?.data);
        let errMessage = err?.response?.data?.message;
        if (errMessage === "Unauthenticated.") {
          dispatch((dispatch) => {
            dispatch({ type: "LOGOUT_POSP" });
          });
          history.push("/");
          message.error("Unauthenticated. Login Again");
        }
      });
  }, [JSON.stringify(tableParams)]);

  // const handleShowEntriesChange = (value) => {
  //   setEntries(value);
  // }
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={`${selectedKeys[0] || ""}`}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columns = [
    {
      title: "Quote No",
      dataIndex: "quick_quote_number",
      sorter: {
        compare: (a, b) => {
          return a.name.localeCompare(b.quick_quote_number);
        },
        multiple: 3,
      },
      ...getColumnSearchProps("quick_quote_number"),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "15%",
      render: (_, record) => (
        <span>
          {record?.status === "Reject" ? (
            <Tag color="#cd201f">Rejected</Tag>
          ) : record?.status === "Quote Pending" ? (
            <Tag color="#87d068">Quote Pending</Tag>
          ) : record?.status === "Document clarification" ? (
            <Tag
              color="#FFD681"
              className="tag-posp"
              icon={<ExclamationCircleOutlined />}
            >
              Document clarification
            </Tag>
          ) : record?.status === "Payment done" ? (
            <Tag
              color="#00b600"
              className="tag-posp"
              icon={<CheckCircleOutlined />}
            >
              Payment done
            </Tag>
          ) : record?.status === "Proceed for payment" ? (
            <Tag
              color="#1890FF"
              className="tag-posp"
              icon={<SyncOutlined spin />}
            >
              Proceed for payment
            </Tag>
          ) : record?.status === "Payment link pending" ? (
            <Tag color="#108ee9">Payment link pending</Tag>
          ) : record?.status === "Pdf generated" ? (
            <Tag
              color="#00b600"
              className="tag-posp"
              icon={<FileDoneOutlined />}
            >
              Pdf generated
            </Tag>
          ) : (
            ""
          )}
        </span>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      sorter: {
        compare: (a, b) => a.remarks - b.remarks,
        multiple: 3,
      },
      ...getColumnSearchProps("remarks"),
    },
  ];
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const onChangeProduct = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const onFinish = (values) => {
    console.log(values);
  };
  const RefreshForm = () => {
    form.resetFields();
  };
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };
  return (
    <div  style={{padding: 20}}>
      <div className="remark-head py-3">
        BPO Remarks</div>
      {/* <Form
        form={form}
        style={{ width: "100%" }}
        requiredMark={false}
        layout='vertical'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}>
        <Row gutter={24} className='align-items-center'>
          <Col span={6}>
            <Form.Item
            label="Expiry Month"
            name='DateOfBirth'
            rules={[
                {
                required: true,
                message: 'Please select DOB',
                },
            ]}
            //initialValue={CustDetail.DateOfBirth ? moment(CustDetail.DateOfBirth) : null}
            >
            <DatePicker
            style={{width: "100%", padding: '8px'}}
            disabledDate={disabledDate}
            format="YYYY-MM-DD"
            defaultPickerValue={getDefaultPickerValue()}
            placeholder="YYYY-MM-DD"
            />
           </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
            label="Product Name">
            <Select
                showSearch
                placeholder="Select a Product"
                optionFilterProp="children"
                onChange={onChangeProduct}
                onSearch={onSearch}
                filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={[
                {
                    value: 'All',
                    label: 'All',
                },
                {
                    value: 'PRIVATE CAR',
                    label: 'PRIVATE CAR',
                },
                {
                    value: 'TWO WHEELER',
                    label: 'TWO WHEELER',
                },
                {
                    value: 'PASSENGER CARRYING',
                    label: 'PASSENGER CARRYING',
                },
                {
                    value: 'GOODS CARRYING',
                    label: 'GOODS CARRYING',
                },
                {
                    value: 'HEALTH',
                    label: 'HEALTH',
                },
                ]}
            />
            </Form.Item>
          </Col>
          <Col span={5}>
          <Form.Item className="mb-0 text-center">
            <div className='btn-group'>
            <Button className='search-btn' type="primary" htmlType="submit" loading={loading} icon={<SearchOutlined />}>
                Search
              </Button>
            <Button className='refresh-btn' 
              type="primary"
              loading={loading}
              onClick={RefreshForm}
              icon={<RedoOutlined />}>
                Refresh
              </Button>
            </div>
            </Form.Item>
          </Col>
        </Row>
      </Form> */}
      <div className="">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={data}
          pagination={tableParams.pagination}
          loading={loading}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
}
